// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { SuitableConnectionsSetVO } from './suitable-connections-set.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SuitableConnectionsVO')
export class SuitableConnectionsVO {

  @JsonProperty('article', 'ArticleVOConverter', true)
  public article: ArticleVO = undefined;
  @JsonProperty('connectionSets', '[SuitableConnectionsSetVO]')
  public connectionSets: SuitableConnectionsSetVO[] = undefined;
}
